import { createSelector } from '@reduxjs/toolkit';
import { selectSearchMetaData } from './selectSearchMetaData';

export const selectQuerystring = createSelector(selectSearchMetaData, searchMeta => {
  const { fullUrlWithoutSeo } = searchMeta;

  if (!fullUrlWithoutSeo) {
    return '';
  }

  const querystringIndex = fullUrlWithoutSeo.indexOf('?');

  return fullUrlWithoutSeo.substring(querystringIndex + 1);
});
